<template>
  <div class="career-wrap">
    <header class="section career-header" :style="{ background : success && (info.bg_color ? info.bg_color : '#f5d784')}">
      <div class="container">
        <div class="columns header is-centered">
          <div class="column is-10 is-full-mobile has-text-centered">
            <h1 class="title is-1 is-spaced">{{ info.title }}</h1>
            <p class="subtitle has-text-weight-medium is-hidden-touch">
              {{ info.desc }}
            </p>
            <button
              class="button is-primary has-text-weight-semibold mt-4"
              @click="goPosition"
              v-if="config.shop_type == 0 && items.length > 0"
            >
              Check Opening Positions
            </button>
          </div>
        </div>
      </div>
    </header>
    <div v-for="(item, index) in job_desc" :key="index">
      <section class="section who" v-if="index % 2 == 0">
        <div class="container py-4">
          <div class="columns is-desktop is-vcentered">
            <div class="column is-hidden-desktop">
              <figure class="image is-5by3">
                <img v-if="item.image" :src="item.image" />
              </figure>
            </div>
            <div class="column is-6-desktop-only">
              <h2 class="title is-spaced">{{ item.title }}</h2>
              <p class="subtitle has-text-justified has-text-grey-darker">
                {{ item.desc }}
              </p>
            </div>
            <div class="column is-hidden-touch">
              <figure class="image is-5by3">
                <img v-if="item.image" :src="item.image" />
              </figure>
            </div>
          </div>
        </div>
      </section>
      <section class="section believe" v-if="index % 2 != 0">
        <div class="container py-4">
          <div class="columns is-desktop is-vcentered">
            <div class="column has-text-right">
              <figure class="image player is-16by9">
                <!-- <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/F2v2bMUY7BQ?autoplay=0&amp;mute=1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen=""
                  class="has-ratio"
                ></iframe> -->
                <img v-if="item.image" :src="item.image" />
              </figure>
            </div>
            <div class="column is-6-desktop-only">
              <h2 class="title is-spaced">{{ item.title }}</h2>
              <p class="subtitle has-text-justified has-text-grey-darker">
                {{ item.desc }}
              </p>
              <!-- <p class="subtitle has-text-justified has-text-grey-darker">
                We believe that safety is always the first priority in
                KidsTopia. If you want to join the team, you must have the same
                understanding about the safety.
              </p> -->
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section feature has-background-info-light">
      <div class="container py-4">
        <div class="columns">
          <div class="column">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/schedule.svg"
              alt="- 1 -"
            />
            <h3 class="title is-3 is-spaced">Flexible Schedule</h3>
            <p
              class="subtitle is-6 has-text-justified has-text-weight-medium has-text-grey-darker"
            >
              We value flexible schedules as a way to balance work and non-work
              responsibilities.
            </p>
          </div>
          <div class="column">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/bulb.svg"
              alt="- 2 -"
            />
            <h3 class="title is-3 is-spaced">Small Team</h3>
            <p
              class="subtitle is-6 has-text-justified has-text-weight-medium has-text-grey-darker"
            >
              You will have higher engagement in the work. Your voice is
              important to our team.
            </p>
          </div>
          <div class="column">
            <img
              class="image is-48x48 mb-3 mt-3"
              src="@/assets/img/discount.svg"
              alt="- 3 -"
            />
            <h3 class="title is-3 is-spaced">Exclusive Discount</h3>
            <p
              class="subtitle is-6 has-text-justified has-text-weight-medium has-text-grey-darker"
            >
              Discounts are available at party package for all employees.
              Unlimited Pass for Full-Time Employees' littles.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- son -->
    <section
      id="section1"
      class="section positions"
      v-if="config.shop_type == 0"
    >
      <div class="container py-4" v-if="items.length > 0">
        <h2 class="title has-text-centered">Open Positions</h2>
        <h2 class="subtitle has-text-centered mb-6">
          View and Apply on Indeed Today
        </h2>
        <table
          class="table is-fullwidth is-striped is-hoverable has-text-centered"
        >
          <thead>
            <tr>
              <th>Title</th>
              <th>Type</th>
              <th>Location</th>
              <th>Action</th>
            </tr>
          </thead>
          <tr
            class="ng-star-inserted"
            v-for="(item, index) in items"
            :key="index"
          >
            <td>
              <strong>{{ item.title }}</strong>
            </td>
            <td>{{ item.type == 0 ? 'Full-Time' : item.type == 1 ? 'Part-Time' : '' }}</td>
            <td>{{ item.shop.name }}</td>
            <td>
              <a
                target="_blank"
                class="has-text-weight-medium"
                :href="item.action"
                >View Role</a
              >
            </td>
          </tr>
        </table>
      </div>
      <div class="has-text-centered pt-5 mt-5">
        <h4 class="title is-4">Have questions regarding the roles?</h4>
        <a
          :href="`mailto:${config.email}`"
          class="button is-primary is-light mr-2 has-text-weight-medium"
          >Email Us</a
        >
      </div>
    </section>
    <!-- parent -->
    <section class="section positions" v-if="config.shop_type == 1">
      <div class="has-text-centered pt-5 mt-5">
        <h4 class="title is-4">Have questions regarding the roles?</h4>
        <a
          :href="`mailto:${config.email}`"
          class="button is-primary is-light mr-2 has-text-weight-medium"
          >Email Us</a
        >
      </div>
    </section>
  </div>
</template>
<script>
import eventBus from "@/utils/eventBus.js";
import { jobList } from "@/server/api.js";
import store from "@/store";

export default {
  components: {},
  data() {
    return {
      items: [],
      job_desc: [],
      info: {},
      success: false
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await jobList({
        });
        if (status == 0) {
          this.info = data.info || {};
          this.success = true;
          this.items = data.items;
          this.job_desc = data.job_desc || [];
        }
      } catch (error) {}
    },
    goPosition() {
      let bridge = document.getElementById("section1");
      let body = document.body;
      let height = 0;

      do {
        height += bridge.offsetTop;
        bridge = bridge.offsetParent;
      } while (bridge !== body);

      window.scrollTo({
        top: height,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scoped>
.career-header {
  margin: 0 auto;
  margin-top: 50px;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
  margin: auto;
}
@media screen and (min-width: 769px) {
  .column.is-10,
  .column.is-10-tablet {
    flex: none;
    width: 83.33333337%;
  }
}
.columns.is-centered {
  justify-content: center;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container {
    max-width: 1344px;
  }
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.columns.is-vcentered {
  align-items: center;
}
.columns:not(:last-child) {
  margin-bottom: 0rem;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: content-box;
}
.title.is-1 {
  font-size: 3rem;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600 !important;
  line-height: 1.125;
}
.title,
.subtitle {
  word-break: break-word;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
@media screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
}
.section {
  padding: 3rem 1.5rem;
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
}

.has-text-centered {
  text-align: center !important;
}

.py-5 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.tag:not(body).is-rounded {
  border-radius: 9999px;
}
.tag:not(body).is-large {
  font-size: 1.25rem;
}
.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.has-text-weight-semibold {
  font-weight: 600 !important;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.has-text-white {
  color: #fff !important;
}
.fas,
.fa-solid {
  font-weight: 900;
}
.mt-5 {
  margin-top: 1.5rem !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
@media screen and (min-width: 1024px) {
  .columns.is-desktop {
    display: flex;
  }
}
@media screen and (min-width: 1024px) {
  .is-hidden-desktop {
    display: none !important;
  }
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.has-text-grey-darker {
  color: #363636 !important;
}
.section {
  padding: 3rem 1.5rem;
}
@media print, screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
@media screen and (max-width: 1023px) {
  .is-hidden-touch {
    display: none !important;
  }
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
  .columns.is-desktop {
    display: flex;
  }
  .is-hidden-desktop {
    display: none !important;
  }
  .section {
    padding: 3rem;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.columns.is-vcentered {
  align-items: center;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}
.image {
  display: block;
  position: relative;
}
.title,
.subtitle {
  word-break: break-word;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.has-text-grey-darker {
  color: #363636 !important;
}
.has-text-justified {
  text-align: justify !important;
}
.image {
  display: block;
  position: relative;
}
.image.is-1by1 .has-ratio,
.image.is-1by1 img,
.image.is-1by2 .has-ratio,
.image.is-1by2 img,
.image.is-1by3 .has-ratio,
.image.is-1by3 img,
.image.is-2by1 .has-ratio,
.image.is-2by1 img,
.image.is-2by3 .has-ratio,
.image.is-2by3 img,
.image.is-3by1 .has-ratio,
.image.is-3by1 img,
.image.is-3by2 .has-ratio,
.image.is-3by2 img,
.image.is-3by4 .has-ratio,
.image.is-3by4 img,
.image.is-3by5 .has-ratio,
.image.is-3by5 img,
.image.is-4by3 .has-ratio,
.image.is-4by3 img,
.image.is-4by5 .has-ratio,
.image.is-4by5 img,
.image.is-5by3 .has-ratio,
.image.is-5by3 img,
.image.is-5by4 .has-ratio,
.image.is-5by4 img,
.image.is-9by16 .has-ratio,
.image.is-9by16 img,
.image.is-16by9 .has-ratio,
.image.is-16by9 img,
.image.is-square .has-ratio,
.image.is-square img {
  height: 100%;
  width: 100%;
}
.block:not(:last-child),
.box:not(:last-child),
.breadcrumb:not(:last-child),
.content:not(:last-child),
.highlight:not(:last-child),
.level:not(:last-child),
.message:not(:last-child),
.notification:not(:last-child),
.pagination:not(:last-child),
.progress:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.tabs:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}
.has-text-justified {
  text-align: justify !important;
}

.has-text-grey-darker {
  color: #363636 !important;
}
.has-background-info-light {
  background-color: #eef3fc !important;
}
.image.is-48x48 {
  height: 48px;
  width: 48px;
}

.image {
  display: block;
  position: relative;
}
.mt-3 {
  margin-top: 0.75rem !important;
}
.mb-3 {
  margin-bottom: 0.75rem !important;
}
.title.is-3 {
  font-size: 2rem;
}
.subtitle.is-6 {
  font-size: 1rem;
}
.button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  color: #fff;
}

.mt-4 {
  margin-top: 1rem !important;
}
.button,
.file-cta,
.file-name,
.input,
.pagination-ellipsis,
.pagination-link,
.pagination-next,
.pagination-previous,
.select select,
.textarea {
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5em;
  justify-content: flex-start;
  line-height: 1.5;
  padding: calc(0.5em - 1px) calc(0.75em - 1px);
  position: relative;
  vertical-align: center;
}
.button {
  background-color: #fff;
  border-color: #dbdbdb;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  justify-content: center;
  padding: calc(0.5em - 1px) 1em;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.table {
  background-color: #fff;
  color: #363636;
}
.table.is-fullwidth {
  width: 100%;
}
.has-text-centered {
  text-align: center !important;
}
.table thead {
  background-color: initial;
}
.table td,
.table th {
  border: solid #dbdbdb;
  border-width: 0 0 1px;
  padding: 0.5em 0.75em;
  vertical-align: center;
}
.table thead td,
.table thead th {
  border-width: 0 0 2px;
  color: #363636;
}
.table th:not([align]) {
  text-align: inherit;
}
tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}
table > tr {
  vertical-align: middle;
}
.table td,
.table th {
  border: solid #dbdbdb;
  border-width: 0 0 1px;
  padding: 0.5em 0.75em;
  vertical-align: center;
}

a {
  color: #e55f61;
  cursor: pointer;
  text-decoration: none;
}
.pt-5 {
  padding-top: 1.5rem !important;
}

.title.is-4 {
  font-size: 1.5rem;
}
.button.is-primary.is-light {
  background-color: #fceeee;
  color: #bd2327;
}

.button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  color: #fff;
}
.button.is-primary.is-light.is-hovered,
.button.is-primary.is-light:hover {
  background-color: #fae3e4;
  border-color: transparent;
  color: #bd2327;
}
</style>


// WEBPACK FOOTER //
// src/pages/career/index.vue